export default __webpack_public_path__ + "static/media/train.3be37f04.svg";